// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pd-page {
  display: flex;
  gap: 50px;
  max-width: 1200px;
  margin: 40px auto;
  padding: 20px;
  font-family: "Segoe UI", sans-serif;
  color: #222;
}
.pd-left {
  flex: 1 1;
  position: sticky;
  top: 25px;
  height: fit-content;
}
.pd-imageWrapper {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  max-width: 320px;
  margin: 0 auto;
}

.pd-imageWrapper img {
  width: 100%;
  height: 300px; 
  object-fit: cover; 
  border-radius: 16px;
  transition: transform 0.35s ease;
  box-shadow: 0 15px 35px rgba(0,0,0,0.12);
}

.pd-imageWrapper img:hover {
  transform: scale(1.05);
}


.pd-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: linear-gradient(135deg, #16a34a, #22c55e);
  color: white;
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 20px;
  font-weight: 500;
}


.pd-right {
  flex: 1 1;
}


.pd-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 8px;
}


.pd-rating {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  font-size: 14px;
}

.pd-rating span {
  color: #f59e0b;
  font-size: 16px;
}


.pd-price {
  color: #16a34a;
  font-size: 28px;
  font-weight: 700;
  margin: 12px 0;
}


.pd-desc {
  color: #666;
  line-height: 1.6;
  font-size: 15px;
}


.pd-actionBox {
  margin-top: 25px;
  background: #fff;
  padding: 18px;
  border: 1px solid #eee;
  border-radius: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
}


.pd-qty {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  padding: 6px 10px;
  border-radius: 10px;
}

.pd-qty button {
  width: 34px;
  height: 34px;
  border: none;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  transition: 0.2s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.pd-qty button:hover {
  background: #f3f4f6;
}


.pd-cart,
.pd-wish {
  padding: 11px 16px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: 0.25s;
}

.pd-cart {
  background: #111;
  color: white;
}

.pd-cart:hover {
  background: #333;
}

.pd-wish {
  background: #ef4444;
  color: white;
}

.pd-wish:hover {
  background: #dc2626;
}


.pd-section {
  margin-top: 30px;
}

.pd-specBox {
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.pd-specRow {
  display: flex;
  justify-content: space-between;
  padding: 14px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 14px;
}

.pd-specRow:last-child {
  border-bottom: none;
}


.pd-reviewBox {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 15px;
  background: #fafafa;
}

.pd-review {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.pd-review:last-child {
  border-bottom: none;
}

.pd-textarea {
  width: 100%;
  height: 100px;
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
  outline: none;
  transition: 0.2s;
}

.pd-textarea:focus {
  border-color: #16a34a;
  box-shadow: 0 0 0 3px rgba(22,163,74,0.1);
}

.pd-reviewBtn {
  margin-top: 10px;
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #16a34a, #22c55e);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  transition: 0.3s;
}

.pd-reviewBtn:hover {
  transform: translateY(-1px);
}


@media (max-width: 768px) {
  .pd-page {
    flex-direction: column;
    gap: 25px;
    margin: 20px auto;
  }

  .pd-left {
    position: relative;
    top: 0;
  }

  .pd-actionBox {
    position: relative;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/productDetails/productDetails.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,SAAO;AACT;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["\n.pd-page {\n  display: flex;\n  gap: 50px;\n  max-width: 1200px;\n  margin: 40px auto;\n  padding: 20px;\n  font-family: \"Segoe UI\", sans-serif;\n  color: #222;\n}\n.pd-left {\n  flex: 1;\n  position: sticky;\n  top: 25px;\n  height: fit-content;\n}\n.pd-imageWrapper {\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.pd-imageWrapper img {\n  width: 100%;\n  height: 300px; \n  object-fit: cover; \n  border-radius: 16px;\n  transition: transform 0.35s ease;\n  box-shadow: 0 15px 35px rgba(0,0,0,0.12);\n}\n\n.pd-imageWrapper img:hover {\n  transform: scale(1.05);\n}\n\n\n.pd-badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  background: linear-gradient(135deg, #16a34a, #22c55e);\n  color: white;\n  padding: 6px 12px;\n  font-size: 12px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n\n.pd-right {\n  flex: 1;\n}\n\n\n.pd-title {\n  font-size: 30px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n\n.pd-rating {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0;\n  font-size: 14px;\n}\n\n.pd-rating span {\n  color: #f59e0b;\n  font-size: 16px;\n}\n\n\n.pd-price {\n  color: #16a34a;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 12px 0;\n}\n\n\n.pd-desc {\n  color: #666;\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n\n.pd-actionBox {\n  margin-top: 25px;\n  background: #fff;\n  padding: 18px;\n  border: 1px solid #eee;\n  border-radius: 14px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.05);\n}\n\n\n.pd-qty {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f9fafb;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n.pd-qty button {\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: 0.2s;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\n}\n\n.pd-qty button:hover {\n  background: #f3f4f6;\n}\n\n\n.pd-cart,\n.pd-wish {\n  padding: 11px 16px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: 0.25s;\n}\n\n.pd-cart {\n  background: #111;\n  color: white;\n}\n\n.pd-cart:hover {\n  background: #333;\n}\n\n.pd-wish {\n  background: #ef4444;\n  color: white;\n}\n\n.pd-wish:hover {\n  background: #dc2626;\n}\n\n\n.pd-section {\n  margin-top: 30px;\n}\n\n.pd-specBox {\n  border: 1px solid #eee;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.pd-specRow {\n  display: flex;\n  justify-content: space-between;\n  padding: 14px;\n  border-bottom: 1px solid #f1f1f1;\n  font-size: 14px;\n}\n\n.pd-specRow:last-child {\n  border-bottom: none;\n}\n\n\n.pd-reviewBox {\n  border: 1px solid #eee;\n  border-radius: 12px;\n  padding: 15px;\n  background: #fafafa;\n}\n\n.pd-review {\n  padding: 12px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.pd-review:last-child {\n  border-bottom: none;\n}\n\n.pd-textarea {\n  width: 100%;\n  height: 100px;\n  margin-top: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  outline: none;\n  transition: 0.2s;\n}\n\n.pd-textarea:focus {\n  border-color: #16a34a;\n  box-shadow: 0 0 0 3px rgba(22,163,74,0.1);\n}\n\n.pd-reviewBtn {\n  margin-top: 10px;\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #16a34a, #22c55e);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: 0.3s;\n}\n\n.pd-reviewBtn:hover {\n  transform: translateY(-1px);\n}\n\n\n@media (max-width: 768px) {\n  .pd-page {\n    flex-direction: column;\n    gap: 25px;\n    margin: 20px auto;\n  }\n\n  .pd-left {\n    position: relative;\n    top: 0;\n  }\n\n  .pd-actionBox {\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
